<template>
  <ion-page id="guarding-page">
    <ion-content>

      <div v-show="showTour">
        <Tour  :tour="tourInfo" :tourTrigger="tourTrigger" @tour-done="tourDone" />
      </div>

      <div id="the_board" :style="styleBoard">
        <CMChessboard :fen="fen" :orientation="orientation" :boardSize="boardSize" />
      </div>

      <div id="the_statusline" v-show="showButtons" :style="styleStatus">
          <span v-if="showThumb == 'down'">
            <ion-icon aria-hidden="true" :icon="thumbsDown" />
            <ion-icon aria-hidden="true" :icon="thumbsDown" />
          </span>
          <span v-if="showThumb == 'up'">
            <ion-icon aria-hidden="true" :icon="thumbsUp" />
            <ion-icon aria-hidden="true" :icon="thumbsUp" />
          </span>
          {{ statusString }}
          <span v-if="showThumb == 'down'">
            <ion-icon aria-hidden="true" :icon="thumbsDown" />
            <ion-icon aria-hidden="true" :icon="thumbsDown" />
          </span>
          <span v-if="showThumb == 'up'">
            <ion-icon aria-hidden="true" :icon="thumbsUp" />
            <ion-icon aria-hidden="true" :icon="thumbsUp" />
          </span>
      </div>
      <div id="the_buttons" v-show="showButtons" :style="styleButtons">
        <div :style="styleRook">
          <GuardingSwitches piece="Rook" :resetTrigger="resetTrigger" :setBackground="errorCheckboxes" 
                            :isPortrait="isPortrait"
          @checkbox-click="checkboxClick"/>
        </div>
        <div :style="styleKnight">
          <GuardingSwitches piece="Knight" :resetTrigger="resetTrigger" :setBackground="errorCheckboxes"
                            :isPortrait="isPortrait"
          @checkbox-click="checkboxClick" />
        </div>
        <div :style="styleBishop">
          <GuardingSwitches piece="Bishop"  :resetTrigger="resetTrigger" :setBackground="errorCheckboxes" 
                            :isPortrait="isPortrait"
          @checkbox-click="checkboxClick" />
        </div> 
        <div :style="styleQueen">
          <GuardingSwitches piece="Queen"  :resetTrigger="resetTrigger" :setBackground="errorCheckboxes"
                            :isPortrait="isPortrait"
          @checkbox-click="checkboxClick" />
        </div>
      </div>
      <div v-show="!showButtons">
        <div :style="styleStatus">
        {{  moveStackString }}
        </div>
      </div>
    </ion-content>
    <Toolbar id="the_toolbar" :elements="toolbarElements" :trigger="toolbarTrigger" 
                      :ignoreClicks="showTour" @toolbar-click="toolbarClick" />
  </ion-page>
</template>

<script setup>

  import { IonIcon,IonItem, IonList, IonButton, IonRange,IonPage, IonContent, modalController } from '@ionic/vue';

  import { thumbsUp, thumbsDown,star } from 'ionicons/icons';
  import { t } from '@/composables/translateText.js'

  import Toolbar from '@/components/Toolbar.vue'
  import CMChessboard from '@/components/CMChessboard.vue'
  import GuardingSwitches from '@/components/GuardingSwitches.vue'
  import { doStartupCheck } from '@/composables/startupCheck.js'
  import ModalErrorMessage from '@/components/ModalErrorMessage.vue'

  import { findToolbarElement, setToolbarElementDisabledFlag, setToolbarElementLabel} 
                from '@/composables/toolbarSupport.js'

  import { ref, watch } from 'vue'

  import { useConnectionStore } from '@/stores/connectionStore';
  import { useGetData } from '@/composables/getData.js'
  import { useWindowSizeStore } from '@/stores/windowSizeStore';

  import { availableWidthHeight, calculateChessBoardRect, isScreenPortraitOrientation } from '@/composables/screenSize'
  import Tour from '@/components/Tour.vue'

  var server_request_sent = false

  const INITIAL_FEN = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1"
  var blankAppendTrigger = " "

  const connectionStore = useConnectionStore()

  const isDark = ref(connectionStore.getDarkmode != "light")
  const menuTrigger = ref(0)
  const tourTrigger = ref(0)
  const tourOption = connectionStore.getTourOption
  //console.log("*** Tour option",tourOption)
  const showTour = ref((tourOption == "show"))

  const STATUS_FONTSIZE = 20
  const STATUS_HEIGHT = STATUS_FONTSIZE * 1.2 + 4
  
  const statusString = ref(t("Click 'Start' to Begin"))

  const showThumb = ref("")

  const SHOW_GUARDING = 2
  const showState = ref(SHOW_GUARDING)

  const showButtons = ref(true)

  const STATE_BEGINNING = 0
  const STATE_BOARD_SHOWING = 1
  const STATE_ANSWER_SHOWING = 2
  const STATE_NEXT_MOVE_SHOWING = 3

  var problemState = STATE_BEGINNING
  var moveNumber = 0

  const isPortrait = ref(true)

  const orientation = ref("white")
  const fen = ref(INITIAL_FEN)
  var initialFen = fen.value
  var updatedFen = initialFen
  var showingInitialFen = true

  // array of the move SANs
  var moveStack = []
  const moveStackString = ref("BLAH, blah, blah, blah, BLAH, blah, blah, blah, BLAH, blah, blah, blah, BLAH, blah, blah, blah, BLAH, blah, blah, blah, BLAH, blah, blah, blah, ")

  var twoCharSelected = []
  const resetTrigger = ref(0)
  var errorCheckboxes = ref("")

  const toolbarTrigger = ref(0)

  const boardSize = ref(300)

  const windowSizeStore = useWindowSizeStore()
  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })

  const TOOLBAR_START = 0
  const TOOLBAR_CHECK = 1
  const TOOLBAR_NEXT = 2
  const TOOLBAR_LIST = 3
  const TOOLBAR_REVEAL = 4
  const TOOLBAR_TOUR = 5

  const toolbarElements = ref([
    { index : TOOLBAR_START, label : t("Start") ,disabled : false },
    { index : TOOLBAR_CHECK, label : t("Check") ,disabled : true },
    { index : TOOLBAR_NEXT, label : t("Next Move") , disabled : true},
    { index : TOOLBAR_LIST, label : t("List") , disabled : true, collapse:true},
    { index : TOOLBAR_REVEAL, label : t("Reveal") , disabled : true, collapse:true},
  ])

   // tour stuff
   const tourInfo = ref({
    id : "guarding",
    video : "https://www.chessvis.com/videos/guarding.mp4",
    elements : [
      { id: "", title: t("Who's Guarding Whom"), text : t("In Andrew Soltis' Book, <b><i>Studying Chess Made Easy</b></i>, he references an exercise cited by the Russian educator Alexey Bartashnikov in 64 magazine.<br><br>The 3 minute video shows the exercise in action. (Note: it hasn't been updated yet but is worthwhile")},
      { id: "", title: t("The Idea"), text : t("In summary, the exercise consists of a board with a random setup of a white queen, rook, knight and bishop.<br><br>Moves are given and after each move, you must determine how the pieces 'guard' each other.")},
      { id: "", title: t("The Catch"), text : t("The catch is that while any number of sequential moves can be done, the visible board is never updated beyond the initial display.<br><br>All moves must be visualized in your mind.")},
      { id: "", title: t("Your Task"), text : t("The screen presentation is that of a board with the four pieces and a set of buttons for you to select indicating that a piece is <b>'guarding'</b> another.")},
      { id: "the_board", title: t("Board only shows 4 pieces"), text : t("Once you 'Start' the exercise, the board will only show the 4 pieces")},
      { id: "the_statusline", title: t("Status Line"), text : t("Here you will see instructions to follow, the move to visualize and how well you did")},

      { id: "the_buttons", title: t("Buttons"), text : t("Your 'job' is to use the buttons to indicate which pieces are 'guarding' the other pieces")},
      { id: "the_toolbar", title: t("Start - Toolbar"), text : t("Will load the 4 pieces in random locations")},
      { id: "the_toolbar", title: t("Check - Toolbar"), text : t("After you are finished using the buttons to indicate the 'guardings', <b>Check</b> your work. The status line will tell you how you did and any errors will cause the buttons to be highlighted")},
      { id: "the_toolbar", title: t("Next Move - Toolbar"), text : t("When you're ready, request the next move. It will be displayed in the 'status line'. Don't forget, the board itself is never updated.")},
      { id: "the_toolbar", title: t("List - Toolbar"), text : t("If you feel really lost and you want to get back on track, this button will show you the sequence of all the moves")},
      { id: "the_toolbar", title: t("Reveal / Revert - Toolbar"), text : t("If you feel really, really lost, this button will update the board to where the pieces are actually located.<br><br>Toggling the button will restore the initial piece locations.")},

    ]
  })

  const styleBoard = ref({
    position : "absolute",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  const styleStatus = ref({
    "text-align" : "center",
    "font-size" : "20px",
    position : "absolute",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  const styleButtons = ref({
    position : "absolute",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  const styleRook = ref({
    position : "absolute",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })
  const styleKnight = ref({
    position : "absolute",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })
  const styleBishop = ref({
    position : "absolute",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })
  const styleQueen = ref({
    position : "absolute",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

  function afterStartupCallbackRoutine(stuffChanged,errorProgram,errorEntry) {
    if (errorProgram != null)
      openErrorModal(errorProgram,errorEntry)
    updateWidthHeights()
    menuTrigger.value++
  }

  doStartupCheck(false,afterStartupCallbackRoutine)

  function tourDone() {
    showTour.value = false
  }

  function updateStyleObjects(boundaries) {
    boardSize.value = boundaries['board'].height

    styleBoard.value.height = boardSize.value + "px"
    styleBoard.value.height = boundaries['board'].height + "px"
    styleBoard.value.width = boundaries['board'].width + "px"

    styleBoard.value.top = boundaries['board'].top + "px"
    styleBoard.value.left = boundaries['board'].left + "px"

    styleButtons.value.height = boundaries['buttons'].height + "px"
    styleButtons.value.width = boundaries['buttons'].width + "px"
    styleButtons.value.top = boundaries['buttons'].top + "px"
    styleButtons.value.left = boundaries['buttons'].left + "px"

    styleStatus.value.height = boundaries['status'].height + "px"
    styleStatus.value.width = boundaries['status'].width + "px"
    styleStatus.value.top = boundaries['status'].top + "px"
    styleStatus.value.left = boundaries['status'].left + "px"

    styleRook.value.height = boundaries['rook'].height + "px"
    styleRook.value.width = boundaries['rook'].width + "px"
    styleRook.value.top = boundaries['rook'].top + "px"
    styleRook.value.left = boundaries['rook'].left + "px"

    styleKnight.value.height = boundaries['knight'].height/2 + "px"
    styleKnight.value.width = boundaries['knight'].width/2 + "px"
    styleKnight.value.top = boundaries['knight'].top + "px"
    styleKnight.value.left = boundaries['knight'].left + "px"

    styleBishop.value.height = boundaries['bishop'].height/2 + "px"
    styleBishop.value.width = boundaries['bishop'].width/2 + "px"
    styleBishop.value.top = boundaries['bishop'].top  + "px"
    styleBishop.value.left = boundaries['bishop'].left + "px"

    styleQueen.value.height = boundaries['queen'].height + "px"
    styleQueen.value.width = boundaries['queen'].width + "px"
    styleQueen.value.top = boundaries['queen'].top + "px"
    styleQueen.value.left = boundaries['queen'].left + "px"

    //console.log("**** boardsize ",boardSize.value)
  }

  function updateWidthHeights() {

    const availableSpace = availableWidthHeight()
    isPortrait.value = isScreenPortraitOrientation(availableSpace)
    const boundaries = (isPortrait.value) ? calculatePortraitWidthHeights(availableSpace) :
                                      calculateLandscapeWidthHeights(availableSpace)
    
    updateStyleObjects(boundaries)
  }

  function calculatePortraitWidthHeights(availableSpace) {

    const hardcodedVerticalSpace = 250
    
    // reserve space for the 'guarding buttons'
    const availableSpaceForBoard = { width : availableSpace.width ,
                height : availableSpace.height - hardcodedVerticalSpace,
                isPortrait : true }

    const boardDimensions = calculateChessBoardRect(availableSpaceForBoard,1.0)

    const boardHeight = boardDimensions.height
    const boardWidth = boardDimensions.width
    const boardPositionTop = boardDimensions.y
    const boardPositionLeft = boardDimensions.x + availableSpace.leftRightIndent

    const statusTop = boardPositionTop + boardHeight
    const statusHeight = STATUS_HEIGHT
    const statusLeft = availableSpace.leftRightIndent
    const statusWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    const buttonsTop = statusTop + statusHeight
    const buttonsLeft = availableSpace.leftRightIndent
    const buttonsHeight = availableSpace.height - statusHeight - boardHeight
    const buttonsWidth = statusWidth

    const rookTop = 0         // within "StyleButtons"
    const rookHeight = buttonsHeight
    const rookWidth = buttonsWidth / 4
    const rookLeft = buttonsLeft

    // Note: piece top are within the "buttons" so should NOT have the topIndent adder

    const result = { board : {
        width : boardWidth,
        height : boardHeight,
        left : boardPositionLeft + availableSpace.leftIndent,
        top : boardPositionTop+ availableSpace.topIndent
      },
      status : {
        width : statusWidth,
        height : statusHeight,
        left : statusLeft + availableSpace.leftIndent,
        top : statusTop+ availableSpace.topIndent
      },
      rook : {
        width : rookWidth,
        height : rookHeight,
        left : rookLeft,
        top : rookTop
      },
      knight : {
        width : rookWidth,
        height : rookHeight,
        left : rookLeft + rookWidth,
        top : rookTop
      },
      bishop : {
        width : rookWidth,
        height : rookHeight,
        left : rookLeft + rookWidth * 2,
        top : rookTop
      },
      queen : {
        width : rookWidth,
        height : rookHeight,
        left : rookLeft + rookWidth * 3,
        top : rookTop
      },
      buttons : {
        width : buttonsWidth,
        height : buttonsHeight,
        left : buttonsLeft + availableSpace.leftIndent,
        top : buttonsTop+ availableSpace.topIndent
      }
    }
    //console.log("board and piece dimensions",result)
    return (result)
  }

  function calculateLandscapeWidthHeights(availableSpace) {

    const hardcodedHorizontalSpace = 250

    // reserve space for the 'guarding' buttons
    const availableSpaceForBoard = { width : availableSpace.width - hardcodedHorizontalSpace,
                height : availableSpace.height ,
                isPortrait : false }
    const boardDimensions = calculateChessBoardRect(availableSpaceForBoard,1.0)

    const boardHeight = boardDimensions.height
    const boardWidth = boardDimensions.width
    const boardPositionTop = boardDimensions.y
    const boardPositionLeft = boardDimensions.x + availableSpace.leftRightIndent

    const statusPositionTop = 0
    const statusPositionLeft = boardPositionLeft + boardWidth + availableSpace.leftRightIndent
    const statusHeight = STATUS_HEIGHT
    const statusWidth = availableSpace.width - statusPositionLeft

    const buttonsPositionTop = STATUS_HEIGHT
    const buttonsPositionLeft = boardPositionLeft + boardWidth + availableSpace.leftRightIndent
    const buttonsHeight = availableSpace.height - STATUS_HEIGHT
    const buttonsWidth = availableSpace.width - buttonsPositionLeft

    const rookTop = STATUS_HEIGHT        // within stylebuttons
    const rookLeft = 0                    // within stylebuttons
    const rookHeight = (availableSpace.height - STATUS_HEIGHT) / 2
    const rookWidth = (availableSpace.width - buttonsPositionLeft) / 4

    const result = { board : {
        width : boardWidth,
        height : boardHeight,
        left : boardPositionLeft + availableSpace.leftIndent,
        top : boardPositionTop+ availableSpace.topIndent
      },
      buttons : {
        width : buttonsWidth,
        height : buttonsHeight,
        left : buttonsPositionLeft + availableSpace.leftIndent,
        top : buttonsPositionTop+ availableSpace.topIndent
      },
      rook : {
        width : rookWidth,
        height : rookHeight,
        left : rookLeft,
        top : rookTop
      },
      knight : {
        width : rookWidth,
        height : rookHeight,
        left : rookLeft + rookWidth,
        top : rookTop
      },
      bishop : {
        width : rookWidth,
        height : rookHeight,
        left : rookLeft + rookWidth * 2,
        top : rookTop
      },
      queen : {
        width : rookWidth,
        height : rookHeight,
        left : rookLeft + rookWidth * 3,
        top : rookTop
      },
      status : {
        width : statusWidth,
        height : STATUS_HEIGHT,
        left : statusPositionLeft + availableSpace.leftIndent,
        top : statusPositionTop+ availableSpace.topIndent
      }
    }
    //console.log("board and movelist dimensions",result)

    return (result)
  }

  watch(() => windowSizeStore.getWindowSize, () => {
    //console.log('*********** WHO'S Guarding -- window size changes detected')
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    //console.log("*** REP TREE new window size",windowSizeRef.value)
    updateWidthHeights()
    menuTrigger.value++
  })

  function toolbarClick(index) {

    // trap that the button should be disabled but the screen hasn't caught up
    var element = findToolbarElement(toolbarElements.value,index)
    if (element != null && element.disabled)
      return

    switch (index) {
      case TOOLBAR_START :
        moveStack = []
        showButtons.value = true
        showingInitialFen = true
        setToolbarElementLabel(toolbarElements.value,TOOLBAR_LIST,t("List"))  
        setToolbarElementLabel(toolbarElements.value,TOOLBAR_REVEAL,t("Reveal"))  
        toolbarTrigger.value++
        getBoard(1,"")
        break
      case TOOLBAR_CHECK :
        const sendBackString = buildCheckString()
        getBoard(2,sendBackString)
        break
      case TOOLBAR_NEXT :
        getBoard(3,"")
        break
      case TOOLBAR_LIST :
        if (showButtons.value) {
          showButtons.value = false
          moveStackString.value = t("Moves") + ": " + moveStack.join("  ")
        }
        else
          showButtons.value = true
        setToolbarElementLabel(toolbarElements.value,TOOLBAR_LIST,(showButtons.value) ? t("List") : t("Hide"))  
        toolbarTrigger.value++
        break;
      case TOOLBAR_REVEAL :
        incrementAppendTrigger()
        if (showingInitialFen) {
          fen.value = updatedFen + blankAppendTrigger
          showingInitialFen = false
        }
        else {
          fen.value = initialFen + blankAppendTrigger
          showingInitialFen = true
        }
        setToolbarElementLabel(toolbarElements.value,TOOLBAR_REVEAL,(showingInitialFen) ? t("Reveal") : t("Revert"))  
        toolbarTrigger.value++
        break;
      case TOOLBAR_TOUR :
        showTour.value = true
        tourTrigger.value++
        return;
    }
}

function checkboxClick(mainPiece,targetPiece,flag) {
  //console.log("checkbox clicked ",mainPiece,targetPiece,flag)

  const mainChar = (mainPiece.substring(0,1) == 'K') ? 'N' : mainPiece.substring(0,1)
  const targetChar = (targetPiece.substring(0,1) == 'K') ? 'N' : targetPiece.substring(0,1)

  const twoChar = mainChar + targetChar
  //console.log("two char",twoChar)

  twoCharSelected[twoChar] = flag

  //console.log("two char array ",twoCharSelected)
}

function buildCheckString() {
  var checkedArray = []
  for (var key in twoCharSelected) {
    //console.log("key ",key,twoCharSelected[key])
    if (twoCharSelected[key])
      checkedArray.push(key)
  }
  const sendBackString = checkedArray.join("|")
  //console.log("Send back string",sendBackString)
  return (sendBackString)
}

function incrementAppendTrigger() {
    if (blankAppendTrigger.length > 64)
      blankAppendTrigger = ""
    blankAppendTrigger += " "
  }

function processJsonResponse(json) {
    //console.log("response from build_guard",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      server_request_sent = false;
      return;
    }

    const requestFlag = json['state']
    switch (requestFlag) {
      case 1 : // initial board
        incrementAppendTrigger()
        fen.value = json['c'] + blankAppendTrigger

        // save the static board
        initialFen = fen.value
        updatedFen = fen.value

        statusString.value = t("Find Initial Guardings")
        resetTrigger.value++
        twoCharSelected = []
        moveNumber = 0
        problemState = STATE_BOARD_SHOWING
        setToolbarElementLabel(toolbarElements.value,TOOLBAR_START,t("Restart"))  
        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_CHECK,false)
        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_NEXT,true)
        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_LIST,false)
        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_REVEAL,false)
        toolbarTrigger.value++
        showThumb.value = ""
        break
      case 2 : // answers
        problemState = STATE_ANSWER_SHOWING
        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_CHECK,true)
        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_NEXT,false)
        toolbarTrigger.value++

        const errorCount = json['c']
        if (errorCount == 0) {
            showThumb.value = "up"
            statusString.value = t("Excellent")
        }
        else {
          showThumb.value = "down"
          if (errorCount == 1)
            statusString.value = "1 " + t("Error")
          else
            statusString.value = errorCount + " " + t("Errors")
        }

        const adds = json['a'].split("|")
        const missings = json['m'].split("|")
        errorCheckboxes.value = adds.concat(missings).join("|")
        break
      case 3 : // next move
        problemState = STATE_NEXT_MOVE_SHOWING
        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_CHECK,false)
        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_NEXT,true)

        toolbarTrigger.value++

        const moveString = json['m']
        moveStack.push(moveString)
        updatedFen = json['fen']

        moveNumber++
        showThumb.value = ""
        statusString.value = "#" + moveNumber + " - " + moveString 
        resetTrigger.value++
        twoCharSelected = []
    }

    // don't send allow multiple 
    server_request_sent = false;

  }

  function getBoard(requestFlag, check) {

    if (server_request_sent)
      return;

    server_request_sent = true;

    var formData = {
      state : requestFlag,
      check : check
    }

    //console.log("formdata ",formData)

    useGetData("chessvis_who_guarding_whom.php", formData, processJsonResponse)
  }

</script>

<style scoped> 

</style>